import { Box } from '@mui/material';
import React from 'react';

import { IllustratedMessage } from '../../Components/IllustratedMessage';
import { DEFAULT_HEADER_ERROR_MESSAGE } from '../../Components/utils';
import { useMenuContext } from '../../ContextState/useMenuContext';

export const MobileErrorView = ({ dataTest }) => {
  const { customErrorMessage } = useMenuContext();
  return (
    <Box>
      <IllustratedMessage
        illustrationType="error-loading"
        dataTest={dataTest}
        headerText={DEFAULT_HEADER_ERROR_MESSAGE}
        messageText={customErrorMessage}
        illustrationHeight={139}
        illustrationWidth={239}
      />
    </Box>
  );
};
